export const lastClickOnWallet = {
  time: 0,
}
/**
 * We suppose that for all browser, the document is visible
 */
export function isDocumentVisible() {
  // @ts-ignore
  if (document.hidden === 'undefined' || document.hidden === undefined) {
    return true
  }
  return !document.hidden
}
